var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css, ThemeProvider } from "styled-components";
import { Body1, Heading4 } from '../doconHeadings/doconHeadings';
import { BaseBox, FlexBox } from '../../shared/Element';
import { doconTheme } from "../../../theme/default";
var handleColors = function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected;
    var _b = theme.v2.menuList, color = _b.color, bgColor = _b.bgColor, borderColor = _b.borderColor, hoverColor = _b.hoverColor, hoverBorderColor = _b.hoverBorderColor, selectedColor = _b.selectedColor, selectedBgColor = _b.selectedBgColor, selectedBorderColor = _b.selectedBorderColor;
    return "\n    color: " + (isSelected ? selectedColor : color) + ";\n    background: " + (isSelected ? selectedBgColor : bgColor) + ";\n    border-color: " + (isSelected ? selectedBorderColor : borderColor) + ";\n    " + (isSelected ? '' : "\n      :hover {\n        color: " + hoverColor + ";\n        border-color: " + hoverBorderColor + ";\n      }") + "\n  ";
};
var FreeTag = styled(Body1)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 10px;\n  padding: 2px 8px;\n  font-weight: 600;\n  color: white;\n  border-radius: 4px;\n  text-transform: uppercase;\n"], ["\n  margin-left: 10px;\n  padding: 2px 8px;\n  font-weight: 600;\n  color: white;\n  border-radius: 4px;\n  text-transform: uppercase;\n"])));
var Subtitle = styled(Body1)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Root = styled(BaseBox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 14px;\n  margin: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid;\n  ", ";\n\n  ", "\n\n  :hover {\n    ", ", ", " { color: currentColor; }\n  }\n"], ["\n  display: inline-block;\n  padding: 14px;\n  margin: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid;\n  ", ";\n\n  ", "\n\n  :hover {\n    ", ", ", " { color: currentColor; }\n  }\n"])), function (props) { return handleColors(props); }, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ", ", " { color: currentColor; }\n  "], ["\n    ", ", ", " { color: currentColor; }\n  "])), Heading4, Subtitle);
}, Heading4, Subtitle);
function ListItem(_a) {
    var index = _a.index, item = _a.item, isSelected = _a.isSelected, onClick = _a.onClick, props = __rest(_a, ["index", "item", "isSelected", "onClick"]);
    function handleOnClick() {
        onClick && onClick({ index: index, item: item });
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Root, __assign({ isSelected: isSelected, onClick: handleOnClick }, props),
            React.createElement(Heading4, { tagAs: 'span', title: item.title, fontWeight: 500 }),
            React.createElement(FlexBox, { alignItems: 'center' },
                React.createElement(Subtitle, { color: doconTheme.v2.colors.text.tertiaryColor, title: item.subtitle }),
                React.createElement(FreeTag, { bg: '#4e9cff', title: item.free ? 'Free' : '' })))));
}
export default styled(ListItem)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
